// Company contact facts for pages outside the legal notice. They come from the
// one data file behind the legal notice, so an address or phone number is
// maintained in exactly one place.
import myInfo from '../translations/pages/impressum/my_info.json';

export const companyContact = {
  street: myInfo.address.street,
  postalCode: myInfo.address.postalCode,
  city: myInfo.address.city,
  country: myInfo.address.country,
  email: myInfo.contact.email,
  phones: myInfo.contact.phones,
  website: 'paioneer-labs.eu',
  managingDirectors: myInfo.personal.managingDirectors
};
